import VentaRetail from "./VentaRetail";

export default VentaRetail;
